module.exports = "<div id=\"messagePopup\">\r\n  <img src=\"../assets/img/icons/ic-info-2.svg\" />\r\n  <b>{{ title }}</b>\r\n  <span>{{ msg }}</span>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/message-dialog/message-dialog.component.html
// module id = ./src/app/shared/components/message-dialog/message-dialog.component.html
// module chunks = main